import { proposedGet, proposedPost } from '@/api/proposedEndpoint'

/**
 * THE switch for the archive's "Get new issues" row. mm-be has no subscribe endpoint for the weekly
 * newsletter, so this is `false`: no request is made, no query is built, and the row draws its real
 * head, the switch held off, and the generic "Not available yet" state under it. Flip it to `true`
 * when the endpoint ships (contract in `asks/nw2.md`).
 */
export const NEWSLETTER_SUBSCRIPTION_AVAILABLE: boolean = false

/** The proposed path: the member's own subscription to the weekly issue. */
const PATH = '/api/v5/newsletters/subscription/'

interface WireSubscription {
  subscribed: boolean
}

export const newsletterSubscriptionService = {
  get: async (): Promise<boolean> => (await proposedGet<WireSubscription>(PATH)).subscribed,

  set: async (subscribed: boolean): Promise<boolean> =>
    (await proposedPost<WireSubscription>(PATH, { subscribed })).subscribed,
}
